<div class="modal-header">
    <button (click)="close()"
            (keydown.enter)="close()"
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button">
        <span class="svg-icon svg-close-primary"></span>
    </button>
</div>
<div class="modal-body notif-styles">
    <div class="notif-styles__content">
        <div class="notif-styles__content-title">
            {{programDisplayData?.notificationModal?.promotionExpired}}
        </div>
        <div class="notif-styles__content-subtitle body-text">
            {{programDisplayData?.notificationModal?.weAreSorry}} {{campaignTitle ? campaignTitle : "offer"}} {{programDisplayData?.notificationModal?.noLongerAvailable}}
        </div>
        <div>
            <button (click)="close()"
                    (keydown.enter)="close()"
                    aria-label="View current offers"
                    class="btn-large btn  pds-btn pds-btn-filled--primary"
                    data-dismiss="modal">
                {{programDisplayData?.notificationModal?.viewOffers}}
            </button>
        </div>
    </div>
</div>
